import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/common/helpers/api-helper";
import rolepermissionApi from "@infrastructure/rolepermission-api";
import { addSuccessNotification } from "../common/notificationSlice";
export const getAllPermissionsAsync = createAsyncThunk('rolePermission/getAllPermissions', async (_, { rejectWithValue }) => {
    try {
        const response = await rolepermissionApi.getAllPermissions();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRolePermissionsByIdAsync = createAsyncThunk('rolePermission/getRolePermissionsById', async (rolePermission, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await rolepermissionApi.getRolePermissionsById(rolePermission);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRolePermissionsByRoleNameAsync = createAsyncThunk('rolePermission/getRolePermissionsByRoleName', async (rolePermission, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await rolepermissionApi.getRolePermissionsByRoleName(rolePermission);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createRolePermissionAsync = createAsyncThunk('rolePermission/createRolePermission', async (rolePermission, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await rolepermissionApi.createRolePermission(rolePermission);
        dispatch(addSuccessNotification('Rol machtigingen succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateRolePermissionAsync = createAsyncThunk('rolePermission/UpdateJobCategory', async (rolePermission, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await rolepermissionApi.updateRolePermission(rolePermission);
        dispatch(addSuccessNotification('Functiecategorieën succesvol bijgewerkt.'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
